import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Api from './Config';
import AverageResponseCards from './AverageResponseCards';
import AverageResponseChart from './AverageResponseChart';
import AverageResponseCsv from './AverageResponseCsv';

const labelStyle = {
  color: '#777',
  fontSize: '14px',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  marginBottom: '30px',
};

const dateStyle = {
  color: '#777',
  fontSize: '14px',
};

const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from(Array(currentYear - 2017), (_, i) => currentYear - i);

  return years.map((item) => {
    return { value: item, label: item };
  });
};

const getMonthDatesFromYear = (year) => {
  const monthNum = Array.from({ length: 12 }, (_, i) => i + 1);
  return monthNum.map((item) => {
    return {
      startDate: `${year}-${item}-01`,
      endDate: `${year}-${item}-31`,
    };
  });
};

const AverageLastResponse = ({ category }) => {
  const [year, setYear] = useState({ value: '2021', label: '2021' });
  const [overAllAverage, setOverAllAverage] = useState(null);
  const [officeAverage, setOfficeAverage] = useState(null);
  const [monthlyDates, setMonthlyDates] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getAverage = async () => {
      setIsLoading(true);
      const startDate = `${year.value}-01-01`;
      const endDate = `${year.value}-12-31`;
      const data = await Api.getAverageLastResponses(category, startDate, endDate, 1);
      if (data) {
        setOverAllAverage(data['avgOverall']);
        setOfficeAverage(data['avgOffice']);
        setCsvData(data['avgByTcodes']);
      }
      setIsLoading(false);
    };

    const chartDates = getMonthDatesFromYear(year.value);
    setMonthlyDates(chartDates);
    getAverage();
  }, [year]);

  return (
    <>
      <div className="well">
        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="col-md-4">
            <h4>Average of Last Data Submitted</h4>
            <p style={dateStyle}>{year.value}</p>
          </div>
          <div className="col-md-8">
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <i className="fa fa-calendar" style={{ fontSize: '20px', marginRight: '10px' }}></i>
              <div style={{ width: 250 }}>
                <Select
                  onChange={(obj) => {
                    setYear(obj);
                  }}
                  value={year}
                  options={getYearOptions()}
                />
              </div>
              <div style={{ marginLeft: 30 }}>
                <AverageResponseCsv
                  startDate={`${year.value}-01-01`}
                  endDate={`${year.value}-12-31`}
                  csvData={csvData}
                  category={category}
                  title="Average of Last Data Submitted"
                  overAllAvg={overAllAverage}
                  isLast={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AverageResponseCards
        averageBio={overAllAverage?.average_bio}
        patientCount={overAllAverage?.patientCount}
        patientInControlPercent={overAllAverage?.patientInControlPercent}
        averageByOffice={officeAverage}
        isLast={true}
        isLoading={isLoading}
        category={category}
      />

      <div style={{ paddingTop: '30px', paddingBottom: '50px' }}>
        <p style={labelStyle}>Monthly Average Systolic & Diastolic</p>
        <AverageResponseChart category={category} monthlyDates={monthlyDates} isLast={true} />
      </div>
    </>
  );
};

export default AverageLastResponse;
